import React, {useEffect, useState} from 'react';
import {Navigate, useNavigate} from 'react-router-dom';
import {api, getCookie, isTokenValid, parseJwtPayload, setCookie} from '../api';


export default function TenantSelector() {
  const navigate = useNavigate();
  const [tenants, setTenants] = useState([]);

  useEffect(() => {
    api('/tenants').then(r => r.ok ? r.json() : []).then(data => {
      if (data.length === 1) {
        const token = getCookie('renewalToken');
        const payload = token ? parseJwtPayload(token) : null;
        const expires = payload?.exp ? new Date(payload.exp * 1000) : null;
        setCookie('tenantId', data[0].id, expires);
        setCookie('tenantName', encodeURIComponent(data[0].name), expires);
        navigate('/', {replace: true});
      } else {
        setTenants(data);
      }
    });
  }, []);

  if (!isTokenValid()) return <Navigate to="/login" replace />;
  const hasTenant = document.cookie.split(';').some(c => c.trim().startsWith('tenantId='));
  if (hasTenant) return <Navigate to="/" replace />;

  const select = (t) => {
    const token = getCookie('renewalToken');
    const payload = token ? parseJwtPayload(token) : null;
    const expires = payload?.exp ? new Date(payload.exp * 1000) : null;
    setCookie('tenantId', t.id, expires);
    setCookie('tenantName', encodeURIComponent(t.name), expires);
    navigate('/');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-gray-900 mb-6 text-center">Select a Tenant</h1>
        <div className="space-y-3">
          {tenants.map(t => (
            <button key={t.id} onClick={() => select(t)}
              className="w-full p-4 text-left bg-gray-50 rounded-lg hover:bg-amber-50 hover:border-amber-600 border-2 border-transparent transition">
              <span className="font-medium text-gray-900">{t.name}</span>
            </button>
          ))}
          {tenants.length === 0 && <p className="text-center text-gray-500">No tenants available.</p>}
        </div>
      </div>
    </div>
  );
}
